import { inputClasses as classes } from '@mui/base/Input';
import { numberInputClasses } from '@mui/base/Unstable_NumberInput';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
export const inputClasses = Object.assign({ 
    // We use numberInputClasses since for now text input does not support readOnly class
    readOnly: numberInputClasses.readOnly, sizeSm: 'input-sm', sizeMd: 'input-md', success: 'input-success', adornmentStart: 'input-adornment-start', adornmentEnd: 'input-adornment-end' }, classes);
export const Root = styled.div(({ theme }) => css `
    // Positioning
    display: flex;
    align-items: center;
    justify-content: center;
    // Font
    font-family: ${theme.globals.font.family};
    font-feature-settings:
      'clig' off,
      'liga' off;
    font-weight: 400;
    border-radius: ${theme.spacing.xxs};
    border: 1px solid ${theme.palette.secondaryAlt};
    background: ${theme.palette.surfaceAlt};
    overflow: hidden;

    // Icons

    svg {
      fill: ${theme.palette.contrastLow};
    }

    // Sizes

    &.${inputClasses.sizeSm} {
      ${typography.xs.regular};
      min-height: 1.75rem;
    }

    &.${inputClasses.sizeMd} {
      ${typography.md.regular};
      min-height: 2.5rem;
    }

    // Multiline

    &.${inputClasses.multiline} {
      padding: 0;
    }

    // States
    &:hover {
      border-color: ${theme.palette.primary};
    }

    &.${inputClasses.focused} {
      border-color: ${theme.palette.primary};
      box-shadow: 0 0 0 3px ${rgba(theme.palette.primary, 0.5)};
    }

    &.${inputClasses.success} {
      border-color: ${theme.palette.success};

      &.${inputClasses.focused} {
        box-shadow: 0 0 0 3px ${rgba(theme.palette.success, 0.5)};
      }
    }

    &.${inputClasses.error} {
      border-color: ${theme.palette.error};

      &.${inputClasses.focused} {
        box-shadow: 0 0 0 3px ${rgba(theme.palette.error, 0.5)};
      }
    }

    &.${inputClasses.disabled} {
      background-color: ${globalTheme.palette.backgroundAlt};
      color: ${theme.palette.secondaryAlt};
      border-color: transparent;

      svg {
        fill: ${theme.palette.secondaryAlt};
      }
    }

    &.${inputClasses.readOnly} {
      ${typography.xs.regular};
      background-color: transparent;
      border-color: transparent;

      svg {
        fill: ${theme.palette.contrastHigh};
      }
    }
  `);
export const HTMLInput = styled.input(({ theme }) => css `
    padding: 0;
    border: 0;
    outline: 0;
    height: 100%;
    width: 100%;
    background: inherit;
    line-height: inherit;
    font-size: inherit;
    color: inherit;

    .${inputClasses.readOnly} &:first-child,
    .${inputClasses.readOnly}.input-md &:first-child {
      padding-left: 0;
    }

    &:first-child {
      padding-left: ${theme.spacing.xs};
    }
    &:last-child {
      padding-right: ${theme.spacing.xs};
    }

    .input-md & {
      &:first-child {
        padding-left: ${theme.spacing.sm};
      }
      &:last-child {
        padding-right: ${theme.spacing.sm};
      }
    }

    &::placeholder {
      color: ${theme.palette.secondaryAlt};
    }
  `);
export const HTMLTextArea = styled.textarea(({ theme, size }) => css `
    width: 100%;
    border-width: 0;
    outline: 0;
    overflow: hidden;
    background: inherit;
    line-height: inherit;
    font-family: ${theme.globals.font.family};
    font-size: inherit;

    padding: ${size === 'md' ? theme.spacing.sm : theme.spacing.xs};
  `);
export const InputAdornment = styled('div')(({ theme }) => css `
    border: 0;
    margin: 0 ${theme.spacing.xxs};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    grid-row: 1/3;

    &.${inputClasses.adornmentStart} {
      margin-left: ${theme.spacing.xs};
    }
    &.${inputClasses.adornmentEnd} {
      margin-right: ${theme.spacing.xs};
    }

    .input-md & {
      margin: 0 ${theme.spacing.xs};

      &.${inputClasses.adornmentStart} {
        margin-left: ${theme.spacing.sm};
      }
      &.${inputClasses.adornmentEnd} {
        margin-right: ${theme.spacing.sm};
      }
    }
  `);
//# sourceMappingURL=Input.styled.js.map